module.exports = __webpack_public_path__ + "img/robot_arm_template_2_button.badd20c8.png";